module.exports = __webpack_public_path__ + "static/media/Test50.b148c21c.bmp";